module.exports = __webpack_public_path__ + "static/media/27OCHA7.98f928d1.jpg";